import React from "react";
import "./skills.css";

const Skills = () => {
  const skills = ["React", "JavaScript", "HTML 5", "CSS", "SCSS", "SEO", "Git/GitHub", "Node.js", "Wordpress & AI", "JIRA", "Trello", "Figma", "Scrum", "Hardware", "Redes", "MySQL", "Photoshop cs6",];

  return (
    <section id="skills" className="skills">
      <h2>Habilidades</h2>
      <div className="skills-container">
        {skills.map((skill, index) => (
          <div key={index} className="skill">
            {skill}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;